
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import 'swiper/swiper-bundle.css';


// init Swiper:
var Swiper_fv = new Swiper('.slide_fv', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	effect: 'fade',
	slidesPerView: 1,
	allowTouchMove: false,
	autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed: 1500,
});

// init Swiper:
var Swiper_bnr = new Swiper('.area-slide_bnr', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	slidesPerView: 1.4,
	spaceBetween: 24,
	centeredSlides : true,
	autoplay: {
        delay: 2000,
        disableOnInteraction: false,
	},
	speed: 3000,
	breakpoints: {
		// 769px以上
		769: {
			slidesPerView: 'auto',
			spaceBetween: 48,
		},
	},
});
